/** @jsxImportSource @emotion/react */
import React from "react";

type LayoutDirection = "TB" | "LR";

export interface LayoutToggleProps {
  value: LayoutDirection;
  onChange: (next: LayoutDirection) => void;
}

const INK = "#1a1c21";

const options: { value: LayoutDirection; label: string }[] = [
  { value: "TB", label: "Vertical" },
  { value: "LR", label: "Horizontal" },
];

const LayoutIcon: React.FC<{ direction: LayoutDirection }> = ({
  direction,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    aria-hidden="true"
  >
    {direction === "TB" ? (
      <>
        <rect x="5" y="1.5" width="6" height="3.5" rx="1" />
        <rect x="5" y="11" width="6" height="3.5" rx="1" />
        <line x1="8" y1="5" x2="8" y2="11" />
      </>
    ) : (
      <>
        <rect x="1.5" y="5" width="3.5" height="6" rx="1" />
        <rect x="11" y="5" width="3.5" height="6" rx="1" />
        <line x1="5" y1="8" x2="11" y2="8" />
      </>
    )}
  </svg>
);

export const LayoutToggle: React.FC<LayoutToggleProps> = ({
  value,
  onChange,
}) => (
  <div
    role="radiogroup"
    aria-label={"Graph layout"}
    style={{
      display: "inline-flex",
      gap: 2,
      padding: 3,
      background: "#fff",
      border: "1px solid #d3dae6",
      borderRadius: 6,
      boxShadow: "0 1px 4px rgba(0, 0, 0, 0.12)",
    }}
  >
    {options.map((opt) => {
      const selected = value === opt.value;
      return (
        <button
          key={opt.value}
          type="button"
          role="radio"
          aria-checked={selected}
          onClick={() => onChange(opt.value)}
          css={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            padding: "4px 10px",
            border: "none",
            borderRadius: 4,
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            color: selected ? "#fff" : INK,
            backgroundColor: selected ? INK : "transparent",
            "&:hover": {
              backgroundColor: selected ? INK : "rgba(26, 28, 33, 0.08)",
            },
          }}
        >
          <LayoutIcon direction={opt.value} />
          {opt.label}
        </button>
      );
    })}
  </div>
);
